<template>
  <ion-page>
    <ion-content class="register" scroll-y="true">
      <div class="header-register"></div>
      <div class="top-radius" />
      <div class="content-register" style="padding: 20px">
        <!-- <center>
          <img
            src="../assets/icons/simple.png"
            alt=""
            style="height: 60%; width: 60%"
          />
        </center> -->
        <h1 style="margin: 0; margin-bottom: 5px">Selamat Datang!</h1>
        <p style="margin: 0">Silakan daftar akun baru</p>
        <div class="input-group">
          <div class="label">
            <h2>Nama Lengkap</h2>
            <span>*</span>
          </div>
          <div class="input ion-activatable ripple-parent">
            <ion-icon class="start" :icon="person" color="primary" />
            <ion-input
              class="fullName"
              type="text"
              placeholder="Contoh: John Doe"
              v-model="fullName"
            />
            <ion-ripple-effect mode="ios" />
          </div>
          <div class="label">
            <h2>Username (Gunakan Email Aktif)</h2>
            <span>*</span>
          </div>
          <div class="input ion-activatable ripple-parent">
            <ion-icon class="start" :icon="mail" color="primary" />
            <ion-input
              class="username"
              type="text"
              placeholder="Contoh: siswa@gmail.com"
              v-model="username"
            />
            <ion-ripple-effect mode="ios" />
          </div>
          <div class="label">
            <h2>Password</h2>
            <span>*</span>
          </div>
          <div class="input ion-activatable ripple-parent">
            <ion-icon class="start" :icon="lockClosed" color="primary" />
            <ion-input
              class="password"
              @keyup.enter="register"
              :type="typePass"
              placeholder="Contoh: password123*"
              v-model="password"
            />
            <ion-ripple-effect mode="ios" />
            <ion-icon
              class="end"
              v-if="typePass == 'password'"
              color="primary"
              :icon="eyeOutline"
              @click.prevent="showPass('text')"
            />
            <ion-icon
              class="end"
              v-else
              color="primary"
              :icon="eyeOffOutline"
              @click.prevent="showPass('password')"
            />
          </div>
          <div class="label">
            <h2>Role</h2>
            <span>*</span>
          </div>
          <div class="input ion-activatable ripple-parent">
            <ion-select v-model="role" placeholder="Pilih Role">
              <ion-select-option value="guru">Pengajar</ion-select-option>
              <ion-select-option value="siswa">Siswa</ion-select-option>
              <ion-select-option value="umum">Umum</ion-select-option>
              <ion-select-option value="orangtua">OrangTuan</ion-select-option>

              <!-- <ion-select-option value="admin">Admin</ion-select-option> -->
            </ion-select>
          </div>
        </div>
        <h5
          class="ion-text-center"
          style="margin: 0; color: var(--ion-color-danger)"
          v-if="errored"
        >
          {{ errMsg }}
        </h5>
        <ion-button
          mode="ios"
          class="register"
          @click.prevent="register"
          expand="block"
        >
          <span style="font-size: 1.5rem; color: white"> Daftar</span>
        </ion-button>

        <ion-button
          mode="ios"
          class="back-to-login"
          @click="$router.push({ name: 'login' })"
          expand="block"
        >
          <span style="font-size: 1.2rem; color: white"> Kembali ke Login</span>
        </ion-button>
      </div>
      <ion-loading
        mode="ios"
        :is-open="loading"
        message="Mohon tunggu..."
        spinner="crescent"
      />
    </ion-content>
  </ion-page>
</template>

<script setup>
import {
  IonPage,
  IonContent,
  IonIcon,
  IonInput,
  IonRippleEffect,
  IonButton,
  IonLoading,
  IonSelect,
  IonSelectOption,
  useBackButton,
} from "@ionic/vue";
import { ref } from "vue";
import {
  mail,
  lockClosed,
  eyeOffOutline,
  eyeOutline,
  person,
} from "ionicons/icons";
import {
  getAuth,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { useRouter } from "vue-router";
import AlertMssg from "../composables/alert";

const loading = ref(false);
const fullName = ref("");
const username = ref("");
const password = ref("");
const typePass = ref("password");
const role = ref(""); // Tambahkan state untuk role
const errMsg = ref("");
const errored = ref(false);
const router = useRouter();
const auth = getAuth();
const db = getFirestore();

useBackButton(-1, () => {
  if (router.currentRoute.value.name == "login") {
    AlertMssg.confirmExit();
  }
});

const register = async () => {
  errored.value = false;
  if (!fullName.value) {
    errored.value = true;
    errMsg.value = "Nama lengkap tidak boleh kosong";
  } else if (!username.value) {
    errored.value = true;
    errMsg.value = "Username tidak boleh kosong";
  } else if (!password.value) {
    errored.value = true;
    errMsg.value = "Password tidak boleh kosong";
  } else if (!role.value) {
    errored.value = true;
    errMsg.value = "Role tidak boleh kosong";
  } else {
    loading.value = true;
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        username.value,
        password.value
      );
      const user = userCredential.user;
      await updateProfile(user, { displayName: fullName.value });

      // Simpan data pengguna ke Firestore dengan role dan status
      await setDoc(doc(db, "users", user.uid), {
        fullName: fullName.value,
        username: username.value,
        email: user.email,
        role: role.value, // Gunakan nilai role yang dipilih
        status: "non-aktif", // Default status
      });

      loading.value = false;
      errored.value = false;
      router.push({ name: "splash" });
      setTimeout(() => {
        fullName.value = "";
        username.value = "";
        password.value = "";
        role.value = "";
      }, 1000);
    } catch (error) {
      loading.value = false;
      errored.value = true;
      errMsg.value = error.message;
    }
  }
};

const showPass = (type) => {
  typePass.value = type;
};
</script>

<style>
ion-content.register {
  --background: #f5f5f3;
}
.register .container {
  margin-top: 60%;
}
.register .container img.logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 250px;
  width: 250px;
  border-radius: 50%;
  border: 5px solid white;
}
.register h2.titleApp {
  font-weight: 600;
  text-align: center;
  font-size: 2rem;
  text-shadow: 1px 0px 1px #cccccc, 0px 1px 1px #eeeeee, 2px 1px 1px #cccccc,
    1px 2px 1px #eeeeee, 3px 2px 1px #cccccc, 2px 3px 1px #eeeeee,
    4px 3px 1px #cccccc, 3px 4px 1px #eeeeee, 5px 4px 1px #cccccc,
    4px 5px 1px #eeeeee, 6px 5px 1px #cccccc, 5px 6px 1px #eeeeee,
    7px 6px 1px #cccccc, 2px 2px 2px rgba(206, 206, 206, 0);
  color: #444444;
  margin-top: 0;
}
.register .container .loader {
  margin-top: -50px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.register ion-spinner.loader {
  transform: scale(1.5);
}
</style>
